"use strict";
var tab_directive_1 = require('./tabs/tab.directive');
var tabset_component_1 = require('./tabs/tabset.component');
var tab_heading_directive_1 = require('./tabs/tab-heading.directive');
var tab_directive_2 = require('./tabs/tab.directive');
exports.TabDirective = tab_directive_2.TabDirective;
var tabset_component_2 = require('./tabs/tabset.component');
exports.TabsetComponent = tabset_component_2.TabsetComponent;
var tab_heading_directive_2 = require('./tabs/tab-heading.directive');
exports.TabHeadingDirective = tab_heading_directive_2.TabHeadingDirective;
exports.TAB_DIRECTIVES = [tab_directive_1.TabDirective, tab_heading_directive_1.TabHeadingDirective, tabset_component_1.TabsetComponent];



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/tabs.js
 ** module id = 827
 ** module chunks = 0
 **/